import { doc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "./firebase";
import { getOriginalSentence } from "./getOriginalSentence";
export const deleteOriginalSentence = async (teacherId, deleteId) => {

  try {
    const teacherRef = doc(db, 'original_sentence', teacherId);
    await getOriginalSentence(teacherId).then(async (beforeObj) => {
      if (!beforeObj) {
        beforeObj = Object();
      }
      const objLen = Object.keys(beforeObj).length;
      let afterObj = Object(objLen - 1);
      for (let i = 1; i <= objLen; i++) {
        if (deleteId > i) {
          afterObj[i] = beforeObj[i];
        } else if (deleteId < i) {
          afterObj[i - 1] = beforeObj[i];
        }
      }
      await setDoc(teacherRef, { ...afterObj });
    });
    return true;


  } catch (err) {
    console.log("Error", err);
    return "error";
  }
}
